import { render, staticRenderFns } from "./art_add.vue?vue&type=template&id=5a1ee8e8&scoped=true&"
import script from "./art_add.vue?vue&type=script&lang=js&"
export * from "./art_add.vue?vue&type=script&lang=js&"
import style0 from "./art_add.vue?vue&type=style&index=0&id=5a1ee8e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ee8e8",
  null
  
)

export default component.exports